import { Warning as WarningIcon } from '@mui/icons-material';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from '@mui/material';

interface EndCallDialogProps {
  open: boolean;
  isRecording: boolean;
  onLeaveOnly: () => void;
  onStopRecordingAndLeave: () => void;
  onCancel: () => void;
}

export function EndCallDialog({
  open,
  isRecording,
  onLeaveOnly,
  onStopRecordingAndLeave,
  onCancel,
}: EndCallDialogProps) {
  if (!isRecording) return null;

  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogTitle>
        <Stack direction="row" alignItems="center" spacing={1}>
          <WarningIcon color="warning" />
          <span>End Call</span>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          You are currently recording. Would you like to leave the call only, or stop recording and
          leave?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} color="inherit">
          Cancel
        </Button>
        <Button onClick={onLeaveOnly} variant="outlined">
          Leave Call
        </Button>
        <Button onClick={onStopRecordingAndLeave} variant="contained" color="warning">
          Stop Recording & Leave
        </Button>
      </DialogActions>
    </Dialog>
  );
}
